var InterventionTypes = {
  INSTALLATION: 0,
  RENEWAL: 1,
  SWAP: 2,
  SAV: 3,
};

module.exports = InterventionTypes;
